<script>
  import { VIEW_OPTION, COLUMN_OPTION } from "./../data/costsofmeasures.js";
  import BarChartRow from "./barChartRow.svelte";
  import rawdata from "../data/costsofmeasures";

  import * as d3 from "d3";

  let selectedView = VIEW_OPTION.accident;
  let selectedColumn = null;
  let tooltipdata = rawdata[0];
  const tooltipinterval = d3.interval(
    () => (tooltipdata = rawdata[~~(Math.random() * rawdata.length)]),
    2500
  );

  const numberFormat = d3.format(",");
  const accidentFormat = d3.format(".2%");

  const Y = d3
    .scaleLog()
    .domain([1, 10 ** 13])
    .range([0, 100]);

  const costBenefitTicks = [0, 2, 4, 6, 8, 10, 12];

  const accidentalTicks = [0, 20, 40, 60, 80, 100];

  $: ticks =
    selectedView === VIEW_OPTION.accident ? accidentalTicks : costBenefitTicks;

  const interval = d3.interval(
    () =>
      (selectedView =
        VIEW_OPTION.accident === selectedView
          ? VIEW_OPTION.costBenefit
          : VIEW_OPTION.accident),
    5000
  );

  $: measures = Object.entries(tooltipdata).reduce((measures, [key, val]) => {
    // txt = txt + val === true ? COLUMN_OPTION[key] : "";
    if (val === true) measures.push(COLUMN_OPTION[key]);
    return measures;
  }, []);
  $: summary =
    measures.slice(0, -1).join(", ") +
    (measures.length > 1 ? " และ " : "") +
    measures.slice(-1);

  $: accidentSaved = accidentFormat(
    1 - tooltipdata.actualAccident / tooltipdata.expectedAccident
  );
  $: measuresCost = numberFormat(~~(tooltipdata.cost / 10 ** 6));
  $: measuresBenefit = numberFormat(~~(tooltipdata.benefit / 10 ** 6));
</script>

<style lang="scss">
  .wrapper {
    width: 100%;

    @media (max-width: 500px) {
      overflow-x: auto;
    }
  }
  .container {
    margin: 0 auto;

    display: flex;
    flex-flow: column nowrap;

    min-width: 50rem;
  }

  .row {
    display: flex;
    align-items: center;
    flex-flow: row nowrap;
    height: 40px;

    &--header {
      & .cell {
        text-align: center;
      }
    }

    &.grey {
      filter: grayscale(1);
      opacity: 0.5;
      transition: all 0.2s;
    }

    &.column {
      outline: 1px solid var(--cl-ippd);
    }
  }

  .cell {
    flex: 0 0 10%;
    max-width: 10%;

    &:last-child {
      flex: 0 0 50%;
      max-width: 50%;
    }

    &--header {
      cursor: default;

      display: flex;
      justify-content: center;
      align-items: center;

      width: 100%;
      height: 100%;

      &.active {
        background-color: var(--cl-ippd);
        border-radius: 7.5%;
        color: white;
      }
    }

    &--axis {
      position: relative;

      &__tick {
        position: absolute;
        top: 0;
      }
    }

    &--legend-box {
      display: flex;
      flex-flow: row wrap;
      justify-content: flex-end;

      margin-bottom: 1.5rem;
    }

    &--toggle {
      flex: 0 0 30%;
      max-width: 30%;
      min-width: 18rem;
      margin-right: auto;

      &-wrapper {
        display: flex;
        border: 1px solid var(--cl-ippd);
        height: 2.25rem;
        border-radius: 0.5rem;
        position: relative;
      }

      &-button {
        flex: 0 0 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        color: var(--cl-ippd);

        &.active {
          color: white;
        }
      }

      &-active {
        position: absolute;
        top: 0;
        width: 50%;
        height: 100%;
        border-radius: 0.5rem;
        transition: left 0.25s;

        background-color: var(--cl-ippd);
        z-index: -1;
      }
    }

    .text {
      transform: translateX(-50%);
      color: grey;
    }

    .line {
      height: 400px;
      margin-top: 5px;
      border-left: 1px solid rgba(grey, 0.25);
    }
  }

  .legend {
    display: flex;
    align-items: center;
    margin: 0 1rem;

    &::before {
      content: "";
      width: 1rem;
      height: 1rem;
      display: block;
      margin-right: 0.5rem;
    }

    &--benefit::before {
      background-color: lightblue;
    }

    &--cost::before {
      background-color: lightcoral;
    }

    &--actual::before {
      background-color: gainsboro;
    }

    &--decrease::before {
      background-color: darkcyan;
    }
  }

  .summary {
    font-size: 1.6rem;
    text-align: center;
    margin-bottom: 2rem;
    line-height: 3rem;
    height: 9rem;

    & .measure {
      color: white;
      padding: 0.2rem 0.4rem;
      background-color: darkred;

      &.accident {
        background-color: darkcyan;
      }

      &.cost {
        background-color: lightcoral;
      }

      &.benefit {
        background-color: lightblue;
      }
    }
  }
</style>

{#if tooltipdata}
  <p class="summary">
    นโยบาย
    <span class="measure">{summary}</span>
    <br />
    {#if selectedView === VIEW_OPTION.accident}
      ทำให้อุบัติเหตุบนถนนลดลง
      <span class="measure accident">{accidentSaved}</span>
    {:else}
      มีต้นทุน
      <span class="measure cost">{measuresCost}</span>
      ล้านบาท และได้ผลประโยชน์
      <span class="measure benefit">{measuresBenefit}</span>
      ล้านบาท
    {/if}
  </p>
{/if}
<div class="wrapper">
  <div class="container" on:mouseenter={() => tooltipinterval.stop()}>
    <div class="row">
      <div class="cell cell--toggle">
        <div class="cell--toggle-wrapper">
          <div
            class="cell--toggle-button"
            class:active={selectedView === VIEW_OPTION.accident}
            on:click={() => {
              interval.stop();
              selectedView = VIEW_OPTION.accident;
            }}>
            {VIEW_OPTION.accident}
          </div>
          <div
            class="cell--toggle-button"
            class:active={selectedView === VIEW_OPTION.costBenefit}
            on:click={() => {
              interval.stop();
              selectedView = VIEW_OPTION.costBenefit;
            }}>
            {VIEW_OPTION.costBenefit}
          </div>
          <span
            class="cell--toggle-active"
            style="left: {selectedView === VIEW_OPTION.accident ? '0%' : '50%'};" />
        </div>
      </div>
      <div class="cell cell--legend-box">
        {#if selectedView === VIEW_OPTION.accident}
          <div class="legend legend--actual">เกิดขึ้นจริง</div>
          <div class="legend legend--decrease">ลดลง</div>
        {:else}
          <div class="legend legend--benefit">ผลประโยชน์ (บาท)</div>
          <div class="legend legend--cost">ต้นทุน (บาท)</div>
        {/if}
      </div>
    </div>
    <div class="row row--header">
      {#each Object.entries(COLUMN_OPTION) as [key, column]}
        <div
          class="cell cell--header {selectedColumn === key ? 'active' : ''}"
          on:mouseenter={() => (selectedColumn = key)}
          on:mouseleave={() => (selectedColumn = null)}>
          {column}
        </div>
      {/each}
      <div class="cell cell--axis">
        {#each ticks as tick}
          <div
            class="cell--axis__tick"
            style="left: {selectedView === VIEW_OPTION.accident ? tick : Y(10 ** tick)}%;">
            <div class="text">
              {#if selectedView === VIEW_OPTION.accident}
                {tick}%
              {:else}
                10
                <sup>{tick}</sup>
              {/if}
            </div>
            <div class="line" />
          </div>
        {/each}
      </div>
    </div>
    {#each rawdata.filter((d) => d.cost) as data}
      <div
        class="row {data[selectedColumn] ? '' : selectedColumn !== null ? 'grey' : ''}"
        class:column={tooltipdata === data}
        on:mouseover={() => (tooltipdata = data)}>
        <BarChartRow {data} {Y} {selectedView} />
      </div>
    {/each}
  </div>
</div>
